'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reduxImmutable = require('redux-immutable');

var _forgottenPasswordModalReducer = require('../../auth/modals/forgottenPassword/forgottenPasswordModalReducer');

var _forgottenPasswordModalReducer2 = _interopRequireDefault(_forgottenPasswordModalReducer);

var _changePasswordModalReducer = require('../../auth/modals/changePassword/changePasswordModalReducer');

var _changePasswordModalReducer2 = _interopRequireDefault(_changePasswordModalReducer);

var _paymentModalReducer = require('../../user/account/payment/paymentModalReducer');

var _paymentModalReducer2 = _interopRequireDefault(_paymentModalReducer);

var _teamManagementModalReducer = require('../../user/account/team/teamManagementModalReducer');

var _teamManagementModalReducer2 = _interopRequireDefault(_teamManagementModalReducer);

var _errorModalReducer = require('../error/modals/errorModalReducer');

var _errorModalReducer2 = _interopRequireDefault(_errorModalReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
exports.default = (0, _reduxImmutable.combineReducers)({
    errorModal: _errorModalReducer2.default,
    forgottenPassword: _forgottenPasswordModalReducer2.default,
    changePassword: _changePasswordModalReducer2.default,
    payment: _paymentModalReducer2.default,
    team: _teamManagementModalReducer2.default
});

// Reducers


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/modalReducer.js
// module id = 1923
// module chunks = 0